<template>
  <div
    class="result-table-mode-selector"
    role="group"
    aria-label="Table or silo map view"
  >
    <button
      type="button"
      class="segment"
      :class="{ 'segment--active': value }"
      :aria-pressed="value"
      @click="setMode(true)"
    >
      <span class="segment__label">Silo view</span>
      <i class="material-icons-outlined segment__icon" aria-hidden="true">schema</i>
    </button>
    <button
      type="button"
      class="segment"
      :class="{ 'segment--active': !value }"
      :aria-pressed="!value"
      @click="setMode(false)"
    >
      <span class="segment__label">Table view</span>
      <i class="material-icons-outlined segment__icon" aria-hidden="true">view_week</i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ResultTableModeSelector',
  props: {
    /** When true, silo / map view is selected; when false, table view. */
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setMode(siloView) {
      if (siloView === this.value) {
        return;
      }
      this.$emit('input', siloView);
    },
  },
};
</script>

<style lang="scss" scoped>
.result-table-mode-selector {
  display: inline-flex;
  align-items: stretch;
  gap: 4px;
  // inset border
  box-shadow: inset 0 0 0 1px #dadada;
  border-radius: 999px;
  background: #fff;
}

.segment {
  flex: 1 1 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  padding: 8px 14px;
  min-height: 36px;
  border: none;
  margin: 0;
  border-radius: 999px;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.2;
  color: #757575;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.segment:focus {
  outline: none;
}

.segment:focus-visible {
  box-shadow: inset 0 0 0 2px rgba(255, 87, 0, 0.45);
  position: relative;
  z-index: 1;
}

.segment--active {
  border: 1px solid #ff5700;
  color: #ff5700;
}

.segment:not(.segment--active):hover {
  background: rgba(0, 0, 0, 0.04);
}

.segment__label {
  white-space: nowrap;
}

.segment__icon {
  flex-shrink: 0;
  font-size: 1.2rem;
  line-height: 1;
}
</style>
